<template>
  <h1>RFID Towel Folding</h1>
  <audio src="/resources/audio/error.wav" autostart="false" loop="false" hidden="true" width="0" height="0" id="audio_error" />
  <div id="page-rfid-dashboard" class="content-section">
    <div class="page-section">

      <div class="content-section">

        <div class="row">
            <div class="col-md-2"></div>
            <div class="col-md-3">
                <div>
                    <FormKit
                        type="button"
                        label="Go Back"
                        input-class="$reset btn-rfid-sm btn btn-rfid btn-associate btn-goback"
                        @click="goTo('Dashboard')"
                        prefix-icon="arrowLeft"
                        prefix-icon-class="btn-rfid-back"
                    ></FormKit>
                </div>
            </div>
           
            <div class="col-md-3">
                <div>
                    <FormKit
                        type="button"
                        label="Finish"
                        input-class="$reset btn-rfid-sm btn btn-rfid btn-assemble btn-goback"
                        @click="goTo('Finish')"
                    ></FormKit>
                </div>
            </div>
            <div class="col-md-1"></div>
             <div class="col-md-3">
              <div>
                <FormKit
                    type="button"
                    label="Print Tickets"
                    input-class="$reset btn-rfid-sm btn btn-rfid btn-re-assign"
                    @click="printTickets()"
                     :disabled="isPrinting"
                ></FormKit>
              </div>
             </div>
        </div>
        <div class="clearfix"></div>
        <div v-if="loading" class="text-center my-5">
            <div class="spinner-border" role="status"></div>
            <div>Loading...</div>
        </div>
        <div class="row mt-5" v-if="!loading">
         <div class="col-md-3">
              <div v-if="orderDetails && orderDetails.id"> <b>Order Number:</b>  <router-link target="_blank" :to="{ name: 'ViewOrder', params: { id: orderDetails.id } }">{{orderDetails.id}}
              </router-link> </div>
         </div>
         <div class="col-md-3">
            <div v-if="orderDetails && customerDetails.customer_id"> <b>Customer Name:</b>  <router-link target="_blank" :to="{ name: 'ViewCustomer', params: { id: customerDetails.customer_id } }">{{customerDetails.first_name}} {{customerDetails.last_name}}
              </router-link> </div>
         </div>
         <div class="col-md-3" v-if="orderDetails && orderDetails.date_due">
           <b>Due Date:</b> {{ formatDateEN(orderDetails.date_due) }}
         </div>
          <div class="col-md-3">
           <b>Item Scanned: </b> {{ totalScannedCount }} / {{ validTags.length }}
         </div>
        </div>

        <div class="clearfix"></div>

        <div class="row mt-3" v-if="!loading">
        
            <div class="col-md-5 folding-table-column">
              <div class="table-wrapper">
                <easy-data-table
                      :headers="headers"
                      :items="sortedScannedItems"
                      :rows-per-page="99999"
                      alternating
                      border-cell
                      hide-footer
                      fixed-header
                      body-height="150"
                  >
                  <template #item-action="item">
                      <button class="btn btn-danger scan-list-remove-btn" @click="removeScannedItem(item)">&#10006;</button>
                    </template>
                </easy-data-table>
              </div>
            </div>

            <div class="col-md-7 folding-issues-column">
                <div>
                  <span class="badge bg-danger fw-bold" v-if="unresolvedCount > 0">{{ unresolvedCount }}</span>
                  <span class="fw-bold" v-if="unresolvedCount <= 0">0</span>
                  <span class="ms-2 fw-bold">Issues to solve</span>
                </div>
                
                <div class="text-center mt-2 issues-holder">
                    <div v-for="(tag, idx) in sortedInvalidTags" :key="tag.epcscanned" 
                        id="epc-{{ tag.epcscanned }} || idx" 
                        :class="['m-2 p-3', getCardClass(tag)]">
                      <div class="card-header d-flex justify-content-between align-items-center">
                        <div><b>EPC:</b> 
                          <span v-if="tag.garment_type" >{{ tag.garment_type }}</span>
                          <span v-else>{{ tag.epcscanned }}</span></div>
                        <div>
                          <button class="btn btn-sm btn-link p-0" @click="toggleCollapse(tag)" :aria-expanded="!isTagCollapsed(tag)">
                            <span v-if="isTagCollapsed(tag)">▶</span>
                            <span v-else>▼</span>
                          </button>
                        </div>
                      </div>
                      <div class="card-content pb-2 pt-2" v-show="!isTagCollapsed(tag)">
                           <div v-if="tag.code === 'CUSTOMER_GARMENT_NOT_IN_TICKET' || tag.code === 'NOT_IN_SERVICE_TICKET'">
                            <div>
                              <span v-if="tag.garment_type" >
                                <router-link :to="{ path: `/garments/${tag.garment_id}` }" target="_blank"  >
                                  {{ tag.garment_type }}
                                </router-link>
                              </span>&nbsp;
                              <span v-if="tag.customer_id != customerDetails.customer_id && tag.customer_name" >
                                <router-link :to="{ name: 'ViewCustomer', params: { id: tag.customer_id } }" target="_blank">
                                  - {{ tag.customer_name || ('Customer ' + tag.customer_id) }}
                                </router-link>
                              </span>
                              <span v-if="!tag.garment_type">{{ tag.epcscanned }}</span>
                              is not in this order</div>
                          
                            <div class="row" v-if="tag.customer_id != customerDetails.customer_id">
                              <div class="col-md-6 mt-3">
                                <FormKit
                                    v-model="tag._garmenttype_id"
                                    type="select"
                                    name="garmenttype_id"
                                    id="garmenttype_id"
                                    placeholder="Select Garment"
                                    :options="tag._accountGarments"
                                    searchable
                                    clearable
                                   @input="onGarmentChange(tag, $event)"
                                  />
                              </div>
                              <div class="col-md-6">
                                <div class="mt-4" v-if="tag._selectedGarmentPrice">
                                  <div>Selected price: <label class="badge bg-info">£{{ tag._selectedGarmentPrice }}</label></div>
                                </div>
                              </div>
                            </div>
                           </div>


                          <div v-if="tag.code === 'GARMENT_NOT_ASSOCIATED' || tag.code === 'GARMENT_NOT_FOUND'">
                            <div>Unassociated Garment encountered. Associate and add?</div>
                            <div class="row" v-if="tag.customer_id != customerDetails.customer_id">
                              <div class="col-md-6 mt-3">
                                <FormKit
                                    v-model="tag._garmenttype_id"
                                    type="select"
                                    name="garmenttype_id"
                                    id="garmenttype_id"
                                    placeholder="Select Garment"
                                    :options="tag._accountGarments"
                                    searchable
                                    clearable
                                   @input="onGarmentChange(tag, $event)"
                                  />
                              </div>
                              <div class="col-md-6">
                                <div class="mt-4" v-if="tag._selectedGarmentPrice">
                                  <div>Selected price: <label class="badge bg-info">£{{ tag._selectedGarmentPrice }}</label></div>
                                </div>
                              </div>
                            </div>
                            <div class="row" v-if="tag.customer_id === customerDetails.customer_id">
                              <div class="col-md-6 mt-3">
                                <FormKit
                                    v-model="tag._garmenttype_id"
                                    type="select"
                                    name="garmenttype_id"
                                    id="garmenttype_id"
                                    placeholder="Select Garment"
                                    :options="tag._accountGarments"
                                    searchable
                                    clearable
                                    @input="selectGarmentOption(tag, $event)"
                                  />
                              </div>
                              
                            </div>

                          </div>

                          <div v-if="tag.showApplyErrors">
                            <div class="alert alert-danger mt-2">
                              <div v-html="tag.applyErrors"></div>
                            </div>
                          </div>

                          <!-- Add more fields as needed -->
                          <!-- //CUSTOMER_GARMENT_NOT_IN_TICKET
                            //GARMENT_FOLDED
                            //NOT_IN_SERVICE_TICKET
                            //GARMENT_NOT_ASSOCIATED -->
                            <div v-if="tag.code === 'CUSTOMER_GARMENT_NOT_IN_TICKET' && allowTagAction(tag)" class="issue-action-row mt-3 mb-1">
                              <button class="btn btn-process issue-action-btn" @click="markRemoved(tag)">Don't Add</button>
                              <button class="btn btn-danger issue-action-btn" @click="addToOrder(tag);">Add</button>
                              <button class="btn btn-danger issue-action-btn" @click="overwriteAddToOrder(tag);" v-if="tag.customer_id != customerDetails.customer_id">Overwrite & Add</button>
                              
                            </div>
                            <div v-if="tag.code === 'NOT_IN_SERVICE_TICKET' && allowTagAction(tag)" class="issue-action-row mt-3 mb-1">
                              <button class="btn btn-process issue-action-btn" @click="markRemoved(tag)">Don't Add</button>
                              <button class="btn btn-danger issue-action-btn" @click="addToOrder(tag); ">Add</button>
                              <button class="btn btn-danger issue-action-btn" @click="overwriteAddToOrder(tag);" v-if="tag.customer_id != customerDetails.customer_id">Overwrite & Add</button>
                              
                            </div>
                            <div v-if="tag.code === 'GARMENT_NOT_ASSOCIATED'  && allowTagAction(tag)" class="issue-action-row mt-3 mb-1">
                              <button class="btn btn-danger issue-action-btn" @click="markRemoved(tag)">No</button>
                              <button class="btn btn-process issue-action-btn" @click="associateAndAddToOrder(tag); ">Yes</button>
                              
                            </div>

                            <div v-if="tag.code === 'GARMENT_NOT_FOUND'  && allowTagAction(tag)" class="issue-action-row mt-3 mb-1">
                               <button class="btn btn-danger issue-action-btn" @click="markRemoved(tag)">No</button>
                              <button class="btn btn-process issue-action-btn" @click="associateAndAddToOrder(tag); ">Yes</button>
                            </div>
                            <div v-if="tag.code === 'INTERNAL_ERROR' && allowTagAction(tag)" class="issue-action-row mt-3 mb-1">
                              <button class="btn btn-danger issue-action-btn" @click="markRemoved(tag)">Remove</button>
                            </div>
                        </div>    
                    </div>
                </div>
            </div>
        </div>
        
      </div>


    </div>
  </div>

    <div class="modal" tabindex="-1" id="showAlertMessagesModal" ref="showAlertMessagesModal" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Attention!</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div v-if="confirmComplete">
            <div class="alert alert-danger">
              <div>{{ finishWarningMessage }}</div>
            </div>
          </div>
          <div v-else="!foldingComplete">
            <div class="alert alert-danger" v-if="error_message">
              <div v-html="error_message"></div>
            </div>
            <FormKit
                v-model="uniquepw"
                type="password"
                name="uniquepw"
                id="uniquepw"
              label="Enter Pin"
              placeholder="Enter Pin"
                validation="required"
            />
          </div>
         
        </div>
        <div class="modal-footer">
          <div v-if="confirmComplete">
            <div style="  float: left;">
              <button type="button" class="btn btn-rfid-sm btn-danger"  @click="confirmCompleteAction" >Yes</button>
            </div>
            <div style="  float: right;margin-left: 30px;">
              <button type="button" class="btn btn-rfid-sm btn-process" data-bs-dismiss="modal">No</button>
            </div>
          </div>
          <div v-else="!foldingComplete">
            <div style="  float: left;">
               <button type="button" class="btn btn-rfid-sm btn-danger" data-bs-dismiss="modal" @click="confirmComplete=true;foldingComplete=true;">Cancel</button>
            </div>
            <div style="  float: left;margin-left: 30px;">
              <button type="button" class="btn btn-rfid-sm btn-process"  @click="foldingFinishAction">Submit</button>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </div>

  <div class="modal" tabindex="-1" id="showConfirmationMessagesModal" ref="showConfirmationMessagesModal" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Success</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="alert alert-success">
            <div>Successfully added to the order.</div>
            <div class="mt-3">Please note that the towel will need to be fed into the folder again</div>
          </div>
         
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-rfid-sm btn-process" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>


<script setup>

import {onMounted, ref, watch, inject, reactive, computed, onUnmounted} from 'vue'
import { useRouter } from 'vue-router'
import 'bootstrap/dist/css/bootstrap.min.css';
import bootstrap from "bootstrap/dist/js/bootstrap.bundle";
import { formatLondon,formatDateEN, formatFullDateEN, formatDateYMD } from '@/utils/dateUtils';
import { closeModal, openModal } from '@/utils/modalUtils';
import { get } from 'lodash';
import VueCookies from "vue-cookies";
import RFIDService from '@/services/RFIDService';
import OrderService from '@/services/OrderService';
import GarmentTypeService from '@/services/GarmentTypeService';
import { main } from '@popperjs/core';

const loading = ref(true);
const router = useRouter();
const orderDetails =  ref({});
const customerDetails =  ref({});
const validTags = ref([]);
const tagsScanned =  ref([]);
const scannedItems = ref([]);
const invalidTags = ref([]);
const initialPiecedUpCount = ref(0);
const currentFoldedCount = ref(0);
const isPrinting = ref(false); 

const showAlertMessagesModal = ref(null);
const showConfirmationMessagesModal = ref(null);
const foldingComplete = ref(false);
const confirmComplete = ref(true);
const error_message = ref("");
const uniquepw = ref("");
const uniquepwConfirmed = ref(false);
const currentServiceTicketID = ref(router.currentRoute.value.params.serviceTicketID || null);
const currentCheckCode = ref(router.currentRoute.value.params.checkCode || null);

const isAudioUnlocked = ref(false);

const unlockAudio = () => {
  if (!isAudioUnlocked.value) {
    // Find all audio elements on the page and unlock them
    const audioElements = document.querySelectorAll('audio');
    audioElements.forEach(sound => {
      const promise = sound.play();
      if (promise !== undefined) {
        promise.then(() => {
          sound.pause(); // Immediately pause after a successful play
        }).catch(error => {
          // This catch is important to prevent errors if play() is interrupted
          console.log("Audio unlock play/pause interrupted.", error);
        });
      }
    });
    isAudioUnlocked.value = true;
    console.log("Audio context unlocked by user interaction.");
  }
};

const DEFAULT_SERVICE_TYPE_ID = process.env.VUE_APP_DEFAULT_SERVICE_TYPE_ID || 1;


const tagsAssociated =  ref([]);
const customerLoadedGarments = ref([]);

 const showSseErrors = ref(false);
 const sseErrors = ref("");
 var eventSource = {
  close: function() {
    console.log('initialized');
  }
};
const unresolvedCount = computed(() => invalidTags.value.filter(tag => !tag._solved && !tag._removed).length);
const sessionScannedCount = computed(() => scannedItems.value.length);
const totalScannedCount = computed(() => currentFoldedCount.value);
const hasSessionFolds = computed(() => sessionScannedCount.value > 0);
const finishWarningMessage = computed(() => {
  if (!hasSessionFolds.value && allInvalidTagsResolved() && validTags.value.length > 0) {
    return 'You have not folded anything, are you sure you want to leave?';
  }

  if (!allInvalidTagsResolved()) {
    return 'There are still issues to be resolved, do you really want to finish Folding?';
  }

  if (totalScannedCount.value != validTags.value.length) {
    return `Only ${totalScannedCount.value} of ${validTags.value.length} items have been folded. Do you really want to finish Folding?`;
  }

  return 'Do you really want to finish Folding?';
});

const sortedScannedItems = computed(() =>
    [...scannedItems.value].sort((a, b) => b.garmentindex - a.garmentindex)
);
const sortedInvalidTags = computed(() =>
  [...invalidTags.value].slice().reverse()
);

const reindexScannedItems = () => {
  scannedItems.value = scannedItems.value.map((item, index) => ({
    ...item,
    garmentindex: index + 1,
  }));
};

const getIncomingFoldedCount = (sseData) => {
  const rawFoldedCount = sseData?.data?.folded_count ?? sseData?.data?.FoldedCount;

  if (rawFoldedCount === undefined || rawFoldedCount === null || rawFoldedCount === '') {
    return null;
  }

  const foldedCount = Number(rawFoldedCount);

  return Number.isFinite(foldedCount) ? foldedCount : null;
};

const isAlreadyPiecedUpScan = (sseData) => {
  return sseData?.data?.already_pieced_up === true || sseData?.data?.AlreadyPieced === true;
};

const headers = [
  { text: "Index", value: "garmentindex", sortable: false  },
  { text: "Timestamp", value: "tagtimestamp", sortable: false, align: "d-none" },
  { text: "EPC Scanned", value: "epcscanned", sortable: false },
  { text: "Garment ID", value: "tag_value", sortable: false },
  { text: "Garment Name", value: "garment_type", sortable: false },
  { text: "", value: "action", sortable: false },
];

const goTo = (pageSection) =>   {
  switch (pageSection) {
    case "Dashboard":
      window.open(
          "/rfid/folding-ticket",
          "_self"
      );
      break;
    case "Finish":
      stopFolding();
      break;
    default:
      console.error("Unknown page section: " + pageSection);
      break;
  }
}
const printTickets = () => {
  if (isPrinting.value) return; // Prevent multiple clicks if already processing
  isPrinting.value = true; // Disable the button

  OrderService.printServiceTickets(orderDetails.value.id)
    .then(response => {
      if (response.data.success === true) {
        console.log("Folding ticket printed successfully.");
      } else {
        alert("Error printing folding ticket: " + response.data.message);
        console.log("Error printing folding ticket: " + response.data.message);
      }
    })
    .catch(e => {
      alert("Error printing folding ticket: " + e);
      console.log("Error printing folding ticket: " + e);
    }).finally(() => {
      isPrinting.value = false; // Re-enable the button in all cases
    });
    
}
//ping session to keep it alive
function pingSession() {
  let userId = VueCookies.get('epos2_userid');
  let idToken = VueCookies.get('epos2_token');
  let userWorkstation = VueCookies.get('epos2_workstationid');

  VueCookies.set('epos2_token',idToken);
  VueCookies.set('epos2_userid',userId);
  VueCookies.set('epos2_workstationid',userWorkstation);
  console.log('API called at', new Date());
}

//check if all invalid tags are resolved or removed - returns boolean
const allInvalidTagsResolved = () => {
  for (let i = 0; i < invalidTags.value.length; i++) {
    const tag = invalidTags.value[i];
    if (!tag._solved && !tag._removed) {
      return false;
    }
  }
  return true;
};
//check if no scanned has been done 
const noScannedTags = () => {
  return !hasSessionFolds.value && allInvalidTagsResolved() && validTags.value.length > 0;
};

//confirm complete action - shows modal if there are unresolved tags or no scanned tags
const confirmCompleteAction = () => {
  if(noScannedTags()) {
    stopFoldingReader();
  } else if (!allInvalidTagsResolved()) {
    confirmComplete.value = false;
    foldingComplete.value = false;
  } else if (totalScannedCount.value != validTags.value.length) {
    stopFoldingReader();
  } 
}
// folding finish action - checks manager pin and stops folding
function foldingFinishAction() {
  let epos_userid = VueCookies.get('epos2_userid');
  RFIDService.checkManagerByPin(epos_userid, uniquepw.value)
    .then(response => {

      if (response.data.success === true) {
        uniquepwConfirmed.value = true;
        error_message.value = "";
        uniquepw.value = "";
        
        stopFolding();
        foldingComplete.value = true;
        confirmComplete.value = true;

        closeModal(showAlertMessagesModal);
        stopFoldingReader();
        return true

      } else {
        console.log("Incorrect Manager Pin");
        error_message.value = "Incorrect Manager Pin";
        return false
      }
    })
    .catch(e => {
      error_message.value = "Incorrect Manager Pin X";
      console.log(e);
      return false
    });
} 
// toggle expand / collapse for a tag (accepts tag object now)
const toggleCollapse = (tag) => {
  tag._collapsed = !tag._collapsed;
  const idx = tagsScanned.value.findIndex(t => t.epcscanned === tag.epcscanned);
  if (idx !== -1) {
    tagsScanned.value[idx]._collapsed = tag._collapsed;
  }
};
// helper: return true if the tag (or epc string) is collapsed
const isTagCollapsed = (tagOrEpc) => {
  if (!tagOrEpc) return false;
  const epc = typeof tagOrEpc === 'string' ? tagOrEpc : tagOrEpc.epcscanned;
  const ts = tagsScanned?.value || [];
  const iv = invalidTags?.value || [];
  const t = iv.find(x => x.epcscanned === epc) || ts.find(x => x.epcscanned === epc);
  return !!(t && t._collapsed);
};

// helper: return true if the tag (or epc string) can be actioned (not solved or removed)
const allowTagAction = (tagOrEpc) => {
  if (!tagOrEpc) return false;
  const epc = typeof tagOrEpc === 'string' ? tagOrEpc : tagOrEpc.epcscanned;
  const ts = tagsScanned?.value || [];
  const iv = invalidTags?.value || [];
  const t = iv.find(x => x.epcscanned === epc) || ts.find(x => x.epcscanned === epc);
  return !!t && t._solved !== true && t._removed !== true;
};

// get card class for a tag (accepts tag object)
const getCardClass = (tag) => {
  if (!tag) return 'alert-danger';
  const ts = tagsScanned?.value || [];
  const iv = invalidTags?.value || [];
  const found = iv.find(t => t.epcscanned === tag.epcscanned) || ts.find(t => t.epcscanned === tag.epcscanned);
  if (!found) return 'alert-danger';
  if (found._solved) return 'alert-success';
  if (found._removed) return 'alert-warning';
  return 'alert-danger';
};

// mark as removed (changes class) instead of removing immediately - accepts tag object
const markRemoved = (tag) => {
  if (!isAudioUnlocked.value) {
    unlockAudio();
  }
  const idx = tagsScanned.value.findIndex(t => t.epcscanned === tag.epcscanned);
  if (idx === -1) return;
  tagsScanned.value[idx]._removed = true;
  tagsScanned.value[idx]._collapsed = true;

  const id = invalidTags.value.findIndex(t => t.epcscanned === tag.epcscanned);
  if (id !== -1) {
    invalidTags.value[id]._removed = true;
    invalidTags.value[id]._collapsed = true;
  }
};

// mark as solved (show success) - accepts tag object
const markSolved = (tag) => {
  if (!isAudioUnlocked.value) {
    unlockAudio();
  }
  const idx = tagsScanned.value.findIndex(t => t.epcscanned === tag.epcscanned);
  if (idx === -1) return;
  tagsScanned.value[idx]._solved = true;
  tagsScanned.value[idx]._collapsed = true;
  validTags.value.push(tagsScanned.value[idx]);

  const id = invalidTags.value.findIndex(t => t.epcscanned === tag.epcscanned);
  if (id !== -1) {
    invalidTags.value[id]._solved = true;
    invalidTags.value[id]._collapsed = true;
  }
};

// remove scanned item from scannedItems list - accepts tag object
const removeScannedItem = (tag) => {
  console.log("Removing scanned item:", tag);
  const idx = scannedItems.value.findIndex(t => t.epcscanned === tag.epcscanned);
  console.log("Found index to remove:", idx);
  if (idx === -1) return;
  if (idx !== -1) {
   //mark the garment back at supplier
    OrderService.setOrderItemStatus(orderDetails.value.id, tag.order_item_id,4) //4 = at supplier
      .then(response => {
        if (response.data.success == "true" || response.data.success === true) {
          scannedItems.value.splice(idx, 1);
          const scannedTagIndex = tagsScanned.value.findIndex(t => t.epcscanned === tag.epcscanned);
          if (scannedTagIndex !== -1) {
            tagsScanned.value.splice(scannedTagIndex, 1);
          }
          currentFoldedCount.value = Math.max(initialPiecedUpCount.value, currentFoldedCount.value - 1);
          reindexScannedItems();
        }
        else {
         // set error on this tag object
          alert("Error removing scanned item: " + (response.data.message || JSON.stringify(response.data)));
          console.log(response);
        }
      })
      .catch(e => {
        alert("Error removing scanned item: " + (e.response.data.message || JSON.stringify(e)));
        console.log(e);
      });
    
  }
};

// select garment option - accepts tag object and garmenttypeId
const selectGarmentOption = (tag, garmenttypeId) => {
  tag._garmenttype_id = garmenttypeId;
};

// on garment type change - fetch price - accepts tag object and garmenttypeId
const onGarmentChange = async (tag, garmenttypeId) => {

  console.log("Garment Type Changed:", garmenttypeId);
  if (!garmenttypeId) {
    tag._selectedGarmentPrice = null;
    return;
  }
  selectGarmentOption(tag, garmenttypeId);

  GarmentTypeService.getServicePrices(garmenttypeId)
      .then(response => {
          console.log("Garment Type Response:", response.data);
          if (response.data.status === "OK") {
            console.log("Garment Type Service Prices:", response.data.data.service_prices);
            // Find the Laundry service by servicetype
            //loop through service prices to find the one with DEFAULT_SERVICE_TYPE_ID
            let laundryService = response.data.data.service_prices
              .find(service => Number(service.servicetype_id) == Number(DEFAULT_SERVICE_TYPE_ID));
                console.log("Laundry Service:", laundryService);
            console.log(" DEFAULT_SERVICE_TYPE_ID Price:", DEFAULT_SERVICE_TYPE_ID);
            if (laundryService) {
              tag._selectedGarmentPrice = laundryService.priceband_standard;
            } else {
              tag._selectedGarmentPrice = 'n/a';
            }
        } 
      })
      .catch(e => {
        console.log(e);
      });
};
// associate and add to order - accepts tag object
const associateAndAddToOrder = (tag) => {
  
  //check if garment type selected
  if (!tag._garmenttype_id || tag._garmenttype_id == 0) {
    alert("Please select a Garment Type to associate.");
    return false; 
  }
  tag.showApplyErrors = false;
  tag.applyErrors = "";

  tagsAssociated.value.push({
      tag_id: tag.epcscanned,
      garmenttype_id: tag._garmenttype_id,
      default_service: Number(DEFAULT_SERVICE_TYPE_ID),
      tag_type: "rfid",
      created_at: tag.tagtimestamp? tag.tagtimestamp : formatLondon(new Date()),
    });

    //associate garments
  RFIDService.applyAllCustomerGarments(customerDetails.value.customer_id, tagsAssociated.value)
      .then(response => {
        if (response.data.success == "true" || response.data.success === true) {

          // The response contains an array of newly created garments.
          const newGarmentsArray = response.data?.data?.garment || [];
          
          // Find the specific new garment data from the response array that matches the tag we just associated.
          const newGarmentDataForThisTag = newGarmentsArray.find(g => g.rfid_value === tag.epcscanned);

          console.log("Updated Tag Data after association:", newGarmentDataForThisTag);
          if (newGarmentDataForThisTag) {
            tag.garment_id = newGarmentDataForThisTag.garment_id;
            tag.garment_type = newGarmentDataForThisTag.garment_type;
            tag.tag_value = newGarmentDataForThisTag.tag_value;
            addToOrder(tag);
          }
         
        }
        else {
          tag.showApplyErrors = true;
          tag.applyErrors = response.data.message || JSON.stringify(response.data);
          markRemoved(tag);
          console.log(response);
        }
      })
      .catch(e => {
        tag.showApplyErrors = true;
        tag.applyErrors = e.response.data.message || JSON.stringify(e);
        markRemoved(tag);
        console.log(e);
      });
};

// overwrite add to order - accepts tag object
const overwriteAddToOrder = (tag) => {
  
  tag.showApplyErrors = false;
  tag.applyErrors = "";
  let garmentId;
  console.log("Adding to order - tag:", tag);
  if (!tag._garmenttype_id || tag._garmenttype_id == 0) {
    tag.showApplyErrors = true;
    tag.applyErrors = "Please select a garment before overwriting.";
    return false;
  }
  if (!tag.garment_id) {
    //find garment id from scanned items
    garmentId = tagsScanned.value.find(item => item.epcscanned === tag.epcscanned)?.garment_id;
    if (!garmentId) {
      alert("Order ID or Garment ID missing.");
      return false
    }
  }
  else {
    garmentId = tag.garment_id;
  }
  console.log("Overwrite Adding to order - garmentId:", garmentId);
  console.log("Overwrite Adding to order - garmentTypeId:", tag._garmenttype_id);
  console.log("Overwrite Adding to order - tag:", tag);
  
  //apply all and after that resetScan
  OrderService.addOrderItems(orderDetails.value.id, garmentId, tag._garmenttype_id, "overwrite")
      .then(response => {
        if (response.data.success == "true" || response.data.success === true) {
          markSolved(tag);
         //restart folding process with new ticket
         /*if (response.data?.data?.service_ticket?.serviceticket_id) {
            currentServiceTicketID.value = "ST000" + response.data.data.service_ticket.serviceticket_id;
          }
          if (response.data?.data?.service_ticket?.checkcode) {
            currentCheckCode.value = response.data.data.service_ticket.checkcode;
          }
          stopFolding().then(() => {
            startFolding(currentServiceTicketID.value, currentCheckCode.value);
            
          }).catch((err) => {
            console.log("Error restarting folding:", err);
          });*/
          openModal(showConfirmationMessagesModal);
        }
        else {
         // set error on this tag object
          tag.showApplyErrors = true;
          tag.applyErrors = response.data.message || JSON.stringify(response.data);
          markRemoved(tag);
          console.log(response);
        }
      })
      .catch(e => {
        tag.showApplyErrors = true;
        tag.applyErrors = e.response.data.message || JSON.stringify(e);
        markRemoved(tag);
        console.log(e);
      });
};
// add to order - accepts tag object
const addToOrder = (tag) => {
  
  tag.showApplyErrors = false;
  tag.applyErrors = "";
  let garmentId;
  console.log("Adding to order - tag:", tag);
  if (!tag._garmenttype_id || tag._garmenttype_id == 0) {
    tag._garmenttype_id = tag.garment_type_id;
  }
  if (!tag.garment_id) {
    //find garment id from scanned items
    garmentId = tagsScanned.value.find(item => item.epcscanned === tag.epcscanned)?.garment_id;
    if (!garmentId) {
      alert("Order ID or Garment ID missing.");
      return false
    }
  }
  else {
    garmentId = tag.garment_id;
  }
  
  console.log("Adding to order - garmentId:", garmentId);
  console.log("Adding to order - garmentTypeId:", tag._garmenttype_id);
  //apply all and after that resetScan
  OrderService.addOrderItems(orderDetails.value.id, garmentId, tag._garmenttype_id, "add")
      .then(response => {
        if (response.data.success == "true" || response.data.success === true) {
          
          /*if (response.data?.data?.service_ticket?.serviceticket_id) {
            currentServiceTicketID.value = "ST000" + response.data.data.service_ticket.serviceticket_id;
          }
          if (response.data?.data?.service_ticket?.checkcode) {
            currentCheckCode.value = response.data.data.service_ticket.checkcode;
          }*/
          markSolved(tag);
          openModal(showConfirmationMessagesModal);
          
        }
        else {
         // set error on this tag object
          tag.showApplyErrors = true;
          tag.applyErrors = response.data.message || JSON.stringify(response.data);
          markRemoved(tag);
          console.log(response);
        }
      })
      .catch(e => {
        tag.showApplyErrors = true;
        tag.applyErrors = e.response?.data?.message || JSON.stringify(e);
        markRemoved(tag);
        console.log(e);
      });
};
// helper: return true if the tag (or epc string) exists and is solved
const tagExistsAndSolved = (tagOrEpc) => {
  const epc = typeof tagOrEpc === 'string' ? tagOrEpc : tagOrEpc.epcscanned;
  const t = tagsScanned.value.find(x => x.epcscanned === epc);
  return !!t && t._solved === true;
};
// filter garments for a specific maintype based on already customerLoadedGarments
const loadMaintypeAccountGarments = (maintype_id = 0) => {
  if (maintype_id == 0) {
    return customerLoadedGarments.value;
  }
  console.log("Loading account garments for maintype_id:", maintype_id);
  console.log("Customer loaded garments:", customerLoadedGarments.value);
  let newGarments = customerLoadedGarments.value
    .filter(g => g.maintype_id == maintype_id)
    .map(g => ({
      label: g.label,
      value: g.value,
      default_price: g.default_price,
      maintype_id: g.maintype_id
    }));
    newGarments.unshift({
      label: " - select garment - ",
      value: "0",
      default_price: 0,
      maintype_id: 0
    });

    return newGarments
};

// add to valid tags - accepts sseData object
const addToValidTags = async (sseData) => {
  const data = sseData?.data ?? null;
  if (!data || data.garment_id == null) {
    // don't crash; push to invalidTags or ignore
    let _accountGarments = [];
    if (sseData.data?.maintype_id && sseData.data.maintype_id != 0) {
      //_accountGarments = await loadAccountGarments(sseData.data.maintype_id);
      _accountGarments = loadMaintypeAccountGarments(sseData.data.maintype_id);
    }
    else {
      //_accountGarments = await loadAccountGarments();
      _accountGarments = loadMaintypeAccountGarments();
    }
    invalidTags.value.push({
      reason: sseData?.error ?? 'MISSING_DATA',
      code: sseData?.code ?? 'NO_CODE',
      epcscanned: sseData?.tag ?? '',
      tagtimestamp: sseData?.timestamp ? formatLondon(sseData.timestamp) : '',
      garment_id: sseData.data?.garment_id ?? '',
      tag_value: sseData.data?.tag_value ?? '',
      garment_type: sseData.data?.garment_type ?? '',
      garment_type_id: sseData.data?.garment_type_id ?? 0,
      maintype_id: sseData.data?.maintype_id ?? 0,
      customer_id: sseData.data?.customer_id ?? '',
      customer_name: sseData.data?.customer_name ?? '',
      _accountGarments: _accountGarments,
      _removed: false,
      _collapsed: false,
      _solved: false,
      showApplyErrors: false,
      applyErrors: ''
    });
    return;
  }
  let sindex = scannedItems.value.length + parseInt(1);
      scannedItems.value.push({
          garmentindex: sindex,
          epcscanned: sseData.tag,
          tagtimestamp: formatLondon(sseData.timestamp),
          garment_id: sseData.data.garment_id,
          tag_value: sseData.data.tag_value,
          garment_type: sseData.data.garment_type,
          customer_id: sseData.data.customer_id,
          customer_name: sseData.data.customer_name,
          order_id: sseData.data.order_id,
          order_item_id: sseData.data.order_item_id,
          _accountGarments: [],
        });
} 
const playSound = (soundtype) => {
  // Only proceed if the user has clicked the "Enable Sound" button
  if (!isAudioUnlocked.value) {
    console.log("Audio is not enabled. Skipping sound playback.");
    return;
  }
  let sound = document.getElementById("audio_"+soundtype);
  sound.currentTime = 0;
  sound.loop = false;
  sound.play();
}
// handle scan - accepts sseData object
const handleScan = async (sseData) => {
  //check if tag is in valid tags

  if (sseData.success === false || sseData.success == 'false') {
    if (isAudioUnlocked.value) {
      playSound('error');
    }
    //CUSTOMER_GARMENT_NOT_IN_TICKET
    //NOT_IN_SERVICE_TICKET
    //GARMENT_NOT_ASSOCIATED
    //GARMENT_NOT_FOUND
    //check if already in invalid tags
    const existsInInvalid = invalidTags.value.some(t => t.epcscanned === sseData.tag);
    if (existsInInvalid) {
      console.log("Tag already in invalid tags:", sseData.tag);
      return;
    }
    let _accountGarments = [];
    if (sseData.data?.maintype_id && sseData.data.maintype_id != 0) {
      //_accountGarments = await loadAccountGarments(sseData.data.maintype_id);
      _accountGarments = loadMaintypeAccountGarments(sseData.data.maintype_id);
    }
    else {
      //_accountGarments = await loadAccountGarments();
      _accountGarments = loadMaintypeAccountGarments();
    }
    console.log("Adding to invalid tags ---- _accountGarments ----:", _accountGarments);
    console.log("Adding to invalid tags ---- sseData ----:", sseData.data?.maintype_id);
   invalidTags.value.push({
          reason: sseData.error,
          code: sseData.code,
          epcscanned: sseData.tag,
          tagtimestamp: formatLondon(sseData.timestamp),
          garment_id: sseData.data?.garment_id ?? '',
          garment_type_id: sseData.data?.garment_type_id ?? 0,
          tag_value: sseData.data?.tag_value ?? '',
          garment_type: sseData.data?.garment_type ?? '',
          maintype_id: sseData.data?.maintype_id ?? 0,
          customer_id: sseData.data?.customer_id ?? '',
          customer_name: sseData.data?.customer_name ?? '',
          _accountGarments: _accountGarments,
          _removed: false,
          _collapsed: false,
          _solved: false,
          showApplyErrors: false,
          applyErrors: ''
        });
        
    return;
  } else {
    //GARMENT_FOLDED
    //check if already in valid tags
    const existsInValid = scannedItems.value.some(t => t.epcscanned === sseData.tag);
    if (existsInValid) {
      console.log("Tag already in valid tags:", sseData.data);
      return;
    }
    addToValidTags(sseData);
    
  }
   
  
}

// start server-sent events stream
const startServerStream = async() => {
  sseErrors.value = "";
  const authToken = VueCookies.get('epos2_token');

   if(eventSource){
    eventSource.close()
  }

  eventSource = new EventSource(process.env.VUE_APP_GO_API_BASE+"/api/rfid/stream?token=" + authToken);
    //eventSource = new EventSource(process.env.VUE_APP_GO_API_BASE+"/api/rfid/stream?token=" + authToken+
     //  "&order_id=" + currentOrderId);
  eventSource.onmessage = (event) => {

    //extend cookies expiration
    pingSession();

    if (event.data && event.data.includes('heartbeat')) {
      // Handle heartbeat event
      sseErrors.value = "";
      showSseErrors.value = false;

      return; // Don't process as normal data
    }
    const sseData = JSON.parse(event.data);
      const incomingFoldedCount = getIncomingFoldedCount(sseData);
      const alreadyPiecedUp = isAlreadyPiecedUpScan(sseData);
    console.log("SSE Data:", sseData);
      showSseErrors.value = false;
      sseErrors.value = "";
        if ((sseData.success === true || sseData.success == 'true') && alreadyPiecedUp) {
          if (incomingFoldedCount !== null) {
            currentFoldedCount.value = incomingFoldedCount;
          }
          console.log("Tag already counted as folded:", sseData.tag);
          return;
        }

        if ((sseData.success === true || sseData.success == 'true') && incomingFoldedCount !== null) {
          currentFoldedCount.value = incomingFoldedCount;
        }

      //remove duplicates (same tag)
      // check by epc string and push object with flags
      if (!tagsScanned.value.some(t => t.epcscanned === sseData.tag)) {
        tagsScanned.value.push({
          reason: sseData.error,
          code: sseData.code,
          epcscanned: sseData.tag,
          tagtimestamp: sseData.timestamp ? formatLondon(sseData.timestamp) : '',
          garment_id: sseData.data?.garment_id ?? '',
          tag_value: sseData.data?.tag_value ?? '',
          garment_type: sseData.data?.garment_type ?? '',
          _accountGarments: [],
          _removed: false,
          _collapsed: false,
          _solved: false
        });
        handleScan(sseData);
      } 
      else if (tagExistsAndSolved(sseData.tag)) {
        //update timestamp
        const idx = tagsScanned.value.findIndex(t => t.epcscanned === sseData.tag);
        if (idx !== -1) {
          tagsScanned.value[idx].tagtimestamp = sseData.timestamp ? formatLondon(sseData.timestamp) : '';
           handleScan(sseData);
        }
      }
      else {
        console.log("Tag already exists");
    }
  };
  eventSource.onerror = function(error) {
    //playSound('error');
    console.error("Error:", error);
    sseErrors.value =  "An error occurred. Session still active?";
    showSseErrors.value = true;
  };
  eventSource.addEventListener("open", function(event) {
    console.log("Stream connection opened");
  });
}
// stop folding reader and redirect to folding ticket page
const stopFoldingReader = async () => {
  if(eventSource){
    eventSource.close()
  }
 
  RFIDService.stopScan()
      .then(response => {
        //redirect to folding ticket page
        window.open(
            "/rfid/folding-ticket",
            "_self"
        );
      })
      .catch(e => {
        console.log(e);
      });
}

// stop folding process
const stopFolding = async () => {

  console.log("Stop folding");

  if (!allInvalidTagsResolved() && !uniquepwConfirmed.value) {
    openModal(showAlertMessagesModal); 
    return
  }
  if (totalScannedCount.value != validTags.value.length) {
    confirmComplete.value = true;
    foldingComplete.value = true;
    openModal(showAlertMessagesModal); 
    return;
  }
  //if(eventSource && eventSource.readyState === 1){
    stopFoldingReader();
}
// start folding process
const startFolding = async (serviceTicketID, checkCode) => {
    loading.value = true;
  try {
    let barcode = serviceTicketID + "/" + checkCode;
   // let barcode = router.currentRoute.value.params.serviceTicketID + "/" + router.currentRoute.value.params.checkCode;

    const startFoldingResponse = await RFIDService.startFolding(barcode);
    console.log("Start Folding Response:", startFoldingResponse);
    if( startFoldingResponse.data && startFoldingResponse.data.data ) {
        orderDetails.value = startFoldingResponse.data.data.order;
        customerDetails.value = get(startFoldingResponse, 'data.data.order.customer', {});
        validTags.value = get(startFoldingResponse, 'data.data.valid_tags', []);
      initialPiecedUpCount.value = Number(get(startFoldingResponse, 'data.data.pieced_up_count', 0)) || 0;
          currentFoldedCount.value = initialPiecedUpCount.value;
        //load loadAccountGarments
        customerLoadedGarments.value = await loadAccountGarments();
    }

     //start stream connection
    startServerStream();
  } catch (error) {
    console.error("Error loading order details:", error);
  } finally {
    loading.value = false;
  }
};
// load account garments - accepts optional masterTypeID to filter garments
const loadAccountGarments = async (masterTypeID = false) => {
  try {
    const response = await RFIDService.getAccountGarmentType(orderDetails.value.customer_id);
    let garments = response.data.data.garmentstype;
    console.log("loadAccountGarments Master Type ID:", masterTypeID);

    // If masterTypeID > 0, filter garments by master type
    if (masterTypeID && masterTypeID > 0) {
      garments = garments.filter(
        g => g.garment_details.maintype_id === masterTypeID
      );
    }

    if (garments.length === 0) {
      return []; // Return an empty array if no garments
    }

    const newGarments = garments.map((g) => ({
      label: g.garment_details.garmenttype,
      value: g.garmenttype_id,
      default_price: g.garment_details.default_price,
      maintype_id: g.garment_details.maintype_id
    }));

    newGarments.unshift({
      label: " - select garment - ",
      value: "0",
      default_price: 0,
      maintype_id: 0
    });

    return newGarments; // This now correctly returns the array from the async function

  } catch (e) {
    console.error("Failed to load account garments:", e);
    return []; // Return an empty array on error
  }
};

onMounted(async () => {
  // Add a one-time event listener for the first user click anywhere on the page
  document.addEventListener('click', unlockAudio, { once: true });

  showAlertMessagesModal.value = new bootstrap.Modal('#showAlertMessagesModal', {});
  showConfirmationMessagesModal.value = new bootstrap.Modal('#showConfirmationMessagesModal', {});
  startFolding(currentServiceTicketID.value, currentCheckCode.value);
});

onUnmounted(() => {
  // Clean up the event listener if the component is destroyed before a click
  document.removeEventListener('click', unlockAudio);
  
  if (eventSource) {
    eventSource.close();
  }
});
</script>


<style scoped>
.main-section > h1:first-child {
  background: var(--bundling-bg-color);
}
.folding-table-column,
.folding-issues-column {
  margin-bottom: 1.5rem;
}
.table-wrapper {
  height: 460px;
  position: relative;
}
.table-wrapper :deep(.vue3-easy-data-table__main) {
  height: 460px;
  overflow: auto;
}
.issues-holder {
  border: solid 1px;
  min-height: 460px;
  max-height: 720px;
  overflow: auto;
  padding: 0.75rem;
}
.scan-list-remove-btn {
  min-width: 2.25rem;
  min-height: 2.25rem;
  font-size: 1.1rem;
  line-height: 1;
}
.issue-action-row {
  display: flex;
  flex-wrap: wrap;
  gap: 2.5rem;
  align-items: center;
  justify-content: center;
}
.issue-action-btn {
  min-width: 7.5rem;
  min-height: 2.8rem;
  padding: 0.6rem 1.1rem;
  font-size: 1rem;
  font-weight: 600;
}
.issues-holder :deep(.formkit-outer) {
  margin-bottom: 0;
}
@media (max-width: 991.98px) {
  .table-wrapper,
  .table-wrapper :deep(.vue3-easy-data-table__main),
  .issues-holder {
    height: auto;
    max-height: none;
    min-height: 0;
  }
}
.garment-options {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding-top: 8px;
  justify-content: center; /* center the row */
  align-items: center;     /* center items vertically */
}
.garment-option {
  border: 1px solid #d0d7de;
  padding: 6px 10px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center; /* center label inside the chip */
  min-height: 32px;
  background: #fff;
  text-align: center;
}
.garment-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  max-width: 140px; /* adjust as needed */
}
.garment-option .radio-indicator {
  width:14px;
  height:14px;
  border-radius:50%;
  border:2px solid #777;
  margin-right:8px;
  box-sizing:border-box;
  background:transparent;
}
.garment-option.selected {
  border-color:#0d6efd;
  background: #e7f1ff;
}
.garment-option.selected .radio-indicator {
  background:#0d6efd;
  border-color:#0d6efd;
}
.garment-label { white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
</style>
